(function () {
  'use strict';

  /* ==================================================================
     Utilidades
     ================================================================== */
  var BAR = '[data-atlekx-ship]';
  var PENDING = 'atlekx-cart__item--pending';
  var REMOVING = 'atlekx-cart__item--removing';

  function money(cents) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, theme.settings && theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function routeRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function usesDrawer() {
    return !!(window.theme && theme.settings && theme.settings.cartType === 'drawer');
  }

  /* ==================================================================
     1. Barra de envio gratis
     ================================================================== */
  function paint(bar, total) {
    var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
    if (!threshold || threshold <= 0) return;

    var remaining = threshold - total;
    if (remaining < 0) remaining = 0;

    var percent = Math.round((total * 100) / threshold);
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    var fill = bar.querySelector('[data-atlekx-ship-fill]');
    if (fill) fill.style.width = percent + '%';

    var label = bar.querySelector('[data-atlekx-ship-text]');
    if (label) {
      if (remaining <= 0) {
        label.innerHTML = bar.getAttribute('data-text-success') || '';
      } else {
        var tpl = bar.getAttribute('data-text-pending') || '';
        label.innerHTML = tpl.replace('[amount]', money(remaining));
      }
    }

    bar.classList.toggle('atlekx-ship--reached', remaining <= 0);
  }

  function paintAll(total) {
    Array.prototype.forEach.call(document.querySelectorAll(BAR), function (bar) {
      paint(bar, total);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-atlekx-ship-cost]'), function (el) {
      var threshold = parseInt(el.getAttribute('data-threshold'), 10);
      if (!threshold || threshold <= 0) return;
      if (total >= threshold) {
        el.setAttribute('hidden', 'hidden');
      } else {
        el.removeAttribute('hidden');
      }
    });
  }

  function refresh() {
    if (!document.querySelector(BAR) && !document.querySelector('[data-atlekx-ship-cost]')) return;
    fetch(routeRoot() + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { paintAll(cart.total_price); })
      .catch(function () {});
  }

  /* ==================================================================
     2. Agregar al carrito: el producto aparece en el cajon al instante
        El tema abre el cajon en cuanto responde /cart/add.js, pero el
        contenido real llega con una segunda peticion. Mientras tanto
        pintamos una fila provisional con los datos que ya tenemos.
     ================================================================== */
  function imageUrl(item, width) {
    var src = item.image || (item.featured_image && item.featured_image.url) || '';
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function pendingItemMarkup(item) {
    var img = imageUrl(item, 200);
    var variants = '';

    if (!item.product_has_only_default_variant && item.options_with_values && item.options_with_values.length) {
      variants = item.options_with_values.map(function (opt) {
        return '<div><span>' + esc(opt.name) + ':</span> ' + esc(opt.value) + '</div>';
      }).join('');
    } else if (!item.product_has_only_default_variant && item.variant_title) {
      variants = '<div>' + esc(item.variant_title) + '</div>';
    }

    return (
      '<div class="cart__item ' + PENDING + '" data-key="' + esc(item.key) + '">' +
        '<div class="cart__image">' +
          (img
            ? '<a href="' + esc(item.url) + '" class="image-wrap"><img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="eager"></a>'
            : '') +
        '</div>' +
        '<div class="cart__item-details">' +
          '<div class="cart__item-title">' +
            '<a href="' + esc(item.url) + '" class="cart__item-name">' + esc(item.product_title) + '</a>' +
            (variants ? '<div class="cart__item--variants">' + variants + '</div>' : '') +
          '</div>' +
          '<div class="cart__item-sub">' +
            '<div><div class="js-qty__wrapper is-loading"><input type="text" class="js-qty__num" value="' + esc(item.quantity) + '" readonly aria-label="Cantidad"></div></div>' +
            '<div class="cart__item-price-col text-right"><span class="cart__price">' + money(item.final_price) + '</span></div>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function showPendingItem(item) {
    if (!usesDrawer()) return;

    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var products = drawer.querySelector('[data-products]');
    if (!products) return;

    drawer.classList.remove('is-empty');

    var list = products.querySelector('.cart__items') || products;
    var existing = list.querySelector('.cart__item[data-key="' + item.key + '"]');

    if (existing) {
      existing.classList.add(PENDING);
      var input = existing.querySelector('.js-qty__num');
      if (input) input.value = item.quantity;
      var wrapper = existing.querySelector('.js-qty__wrapper');
      if (wrapper) wrapper.classList.add('is-loading');
    } else {
      list.insertAdjacentHTML('afterbegin', pendingItemMarkup(item));
    }

    // Red de seguridad: si el tema no reconstruye el cajon, lo forzamos
    window.setTimeout(function () {
      if (drawer.querySelector('.' + PENDING)) {
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
    }, 5000);
  }

  document.addEventListener('ajaxProduct:added', function (event) {
    refresh();

    var detail = event.detail || {};
    var item = detail.product;
    if (item && item.items && item.items.length) item = item.items[0];
    if (!item || !item.key) return;

    showPendingItem(item);
  });

  /* ==================================================================
     3. Carrito: quitar o cambiar cantidades sin sensacion de fallo
        - La fila se atenua o desaparece al instante.
        - El enlace "Quitar" usa la misma ruta AJAX que el selector.
        - Con la respuesta del carrito se corrigen filas, subtotal,
          contador y el estado de carrito vacio.
     ================================================================== */
  function rowFor(key, wrapper) {
    if (wrapper && wrapper.closest) {
      var row = wrapper.closest('.cart__item');
      if (row) return row;
    }
    return key ? document.querySelector('.cart__item[data-key="' + key + '"]') : null;
  }

  function restoreRow(row) {
    row.classList.remove(REMOVING, PENDING);
    row.removeAttribute('aria-hidden');
    row.hidden = false;
  }

  function markRow(row, qty) {
    if (!row) return;

    if (qty === 0) {
      row.classList.add(REMOVING);
      row.setAttribute('aria-hidden', 'true');
      window.setTimeout(function () {
        if (row.classList.contains(REMOVING)) row.hidden = true;
      }, 220);
    } else {
      row.classList.add(PENDING);
    }

    // Si en 8 s no llego respuesta, se restaura para no ocultar algo que sigue en el carrito
    window.setTimeout(function () {
      if (row.isConnected) restoreRow(row);
    }, 8000);
  }

  ['cart:quantity.cart-page', 'cart:quantity.cart-cart-drawer'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var detail = event.detail || [];
      var qty = parseInt(detail[1], 10);
      if (isNaN(qty)) return;
      markRow(rowFor(detail[0], detail[2]), qty);
    });
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cart__remove a');
    if (!link) return;

    var row = link.closest('.cart__item');
    var form = link.closest('form[data-location]');
    var key = row && row.getAttribute('data-key');
    if (!row || !form || !key) return;

    event.preventDefault();

    var input = row.querySelector('.js-qty__num');
    if (input) input.value = 0;

    document.dispatchEvent(new CustomEvent('cart:quantity.cart-' + form.getAttribute('data-location'), {
      detail: [key, '0', row.querySelector('.js-qty__wrapper')]
    }));
  });

  function syncFromCart(cart) {
    if (!cart || !cart.items) return;

    var byKey = {};
    cart.items.forEach(function (item) { byKey[item.key] = item; });

    Array.prototype.forEach.call(document.querySelectorAll('.cart__item[data-key]'), function (row) {
      var item = byKey[row.getAttribute('data-key')];
      if (!item) {
        row.remove();
        return;
      }
      restoreRow(row);
      var input = row.querySelector('.js-qty__num');
      if (input && String(input.value) !== String(item.quantity)) input.value = item.quantity;
      var price = row.querySelector('.cart__item-price-col .cart__price:not(.cart__price--strikethrough)');
      if (price) price.innerHTML = money(item.final_price);
    });

    Array.prototype.forEach.call(document.querySelectorAll('form[data-location] [data-subtotal]'), function (el) {
      el.innerHTML = money(cart.total_price);
    });

    Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble-num'), function (el) {
      el.textContent = cart.item_count;
    });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-link__bubble'), function (el) {
      el.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
    });

    var drawer = document.getElementById('CartDrawer');
    if (drawer) drawer.classList.toggle('is-empty', cart.item_count === 0);

    var pageForm = document.getElementById('CartPageForm');
    if (pageForm) {
      var emptyNote = document.querySelector('[data-atlekx-cart-empty]');
      pageForm.hidden = cart.item_count === 0;
      if (emptyNote) emptyNote.hidden = cart.item_count !== 0;
    }
  }

  document.addEventListener('cart:updated', function (event) {
    var cart = event.detail && event.detail.cart;
    if (cart && typeof cart.total_price === 'number') {
      paintAll(cart.total_price);
      syncFromCart(cart);
    } else {
      refresh();
    }
  });

  /* ==================================================================
     4. Vista rapida: spinner propio en "Agregar al carrito"
        No depende de la clase btn--loading del tema (que dentro del
        modal no llega a verse): se inserta un anillo giratorio y se
        oculta el texto hasta que el tema responde.
     ================================================================== */
  var QV_LOADING = 'atlekx-atc--loading';
  var QV_FORM = '.modal--quick-shop form[action*="/cart/add"]';

  function qvRelease(btn) {
    if (!btn) return;
    btn.classList.remove(QV_LOADING);
    btn.removeAttribute('aria-busy');
    if (btn.atlekxTimer) {
      window.clearTimeout(btn.atlekxTimer);
      btn.atlekxTimer = null;
    }
  }

  function qvReleaseAll() {
    Array.prototype.forEach.call(document.querySelectorAll('.' + QV_LOADING), qvRelease);
  }

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(QV_FORM)) return;

      var btn = form.querySelector('.add-to-cart');
      if (!btn || btn.disabled) return;

      if (!btn.querySelector('.atlekx-atc__spinner')) {
        var spinner = document.createElement('span');
        spinner.className = 'atlekx-atc__spinner';
        spinner.setAttribute('aria-hidden', 'true');
        btn.appendChild(spinner);
      }

      btn.classList.add(QV_LOADING);
      btn.setAttribute('aria-busy', 'true');

      // Red de seguridad por si el tema no avisa (error de red, etc.)
      if (btn.atlekxTimer) window.clearTimeout(btn.atlekxTimer);
      btn.atlekxTimer = window.setTimeout(function () {
        qvRelease(btn);
      }, 12000);
    },
    true
  );

  ['ajaxProduct:added', 'ajaxProduct:error'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var form = event.target && event.target.matches && event.target.matches('form') ? event.target : null;
      if (form) {
        qvRelease(form.querySelector('.' + QV_LOADING));
      } else {
        qvReleaseAll();
      }
    });
  });

  document.addEventListener('drawerOpen', qvReleaseAll);

  document.addEventListener('cart:build', refresh);

  document.addEventListener('shopify:section:load', function () {
    refresh();
  });
})();
